import types from "./types";

const INITIAL_STATE = {
	sampleCategories: null,
	sampleCategoriesError: null,
	sampleCategoriesLoading: false,

	//create
	createsampleCategories: null,
	createsampleCategoriesError: null,
	createsampleCategoriesLoading: false,

	//update
	updatesampleCategories: null,
	updatesampleCategoriesError: null,
	updatesampleCategoriesLoading: false,

	//delete
	deletesampleCategories: null,
	deletesampleCategoriesError: null,
	deletesampleCategoriesLoading: false,

	//single item

	singleItem: null,
};

const SampleCategoriesReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case types.GET_SAMPLE_CATEGORIES_START:
			return {
				...state,
				sampleCategories: null,
				sampleCategoriesError: null,
				sampleCategoriesLoading: true,
			};
		case types.GET_SAMPLE_CATEGORIES_SUCCESS:
			return {
				...state,
				sampleCategories: action.payload,
				sampleCategoriesLoading: false,
			};
		case types.GET_SAMPLE_CATEGORIES_ERROR:
			return {
				...state,
				sampleCategoriesError: action.payload,
				sampleCategoriesLoading: false,
			};
		case types.GET_SAMPLE_CATEGORIES_RESET:
			return {
				...state,
				sampleCategoriesError: null,
				sampleCategoriesLoading: false,
			};
		//create

		case types.CREATE_SAMPLE_CATEGORIES_START:
			return {
				...state,
				createsampleCategories: null,
				createsampleCategoriesError: null,
				createsampleCategoriesLoading: true,
			};
		case types.CREATE_SAMPLE_CATEGORIES_SUCCESS:
			return {
				...state,
				createsampleCategories: action.payload,
				createsampleCategoriesLoading: false,
			};
		case types.CREATE_SAMPLE_CATEGORIES_ERROR:
			return {
				...state,
				createsampleCategoriesError: action.payload,
				createsampleCategoriesLoading: false,
			};
		case types.CREATE_SAMPLE_CATEGORIES_RESET:
			return {
				...state,
				createsampleCategoriesError: null,
				createsampleCategoriesLoading: false,
			};
		//delete

		case types.DELETE_SAMPLE_CATEGORIES_START:
			return {
				...state,
				deletesampleCategories: null,
				deletesampleCategoriesError: null,
				deletesampleCategoriesLoading: true,
			};
		case types.DELETE_SAMPLE_CATEGORIES_SUCCESS:
			return {
				...state,
				deletesampleCategories: action.payload,
				deletesampleCategoriesLoading: false,
			};
		case types.DELETE_SAMPLE_CATEGORIES_ERROR:
			return {
				...state,
				deletesampleCategoriesError: action.payload,
				deletesampleCategoriesLoading: false,
			};
		case types.DELETE_SAMPLE_CATEGORIES_RESET:
			return {
				...state,
				deletesampleCategories: null,
				deletesampleCategoriesError: null,
				deletesampleCategoriesLoading: false,
			};

		//update
		case types.UPDATE_SAMPLE_CATEGORIES_START:
			return {
				...state,
				updatesampleCategories: null,
				updatesampleCategoriesError: null,
				updatesampleCategoriesLoading: true,
			};
		case types.UPDATE_SAMPLE_CATEGORIES_SUCCESS:
			return {
				...state,
				updatesampleCategories: action.payload,
				updatesampleCategoriesLoading: false,
			};
		case types.UPDATE_SAMPLE_CATEGORIES_ERROR:
			return {
				...state,
				updatesampleCategoriesError: action.payload,
				updatesampleCategoriesLoading: false,
			};
		case types.UPDATE_SAMPLE_CATEGORIES_RESET:
			return {
				...state,
				updatesampleCategories: null,
				updatesampleCategoriesError: null,
				updatesampleCategoriesLoading: false,
			};

		default:
			return { ...state };
	}
};

export default SampleCategoriesReducer;
